import { render, staticRenderFns } from "./MetaSendButton.vue?vue&type=template&id=652e7d6b&"
import script from "./MetaSendButton.vue?vue&type=script&lang=js&"
export * from "./MetaSendButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports